import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-genera-ricevuta',
  templateUrl: './genera-ricevuta.component.html',
  styleUrls: ['./genera-ricevuta.component.css']
})
export class GeneraRicevutaComponent implements OnInit {
  titolo: string = '';

  constructor(public dialogRef: MatDialogRef<GeneraRicevutaComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = ''
  }

  ngOnInit(): void {
  }

  btnGeneraRicevuta() { }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

  btnSalva() {

    const obj = {

    }

    this.srvUtilita.postObj('Utenti/PostGeneraRicevuta', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }


}
